import reactStringReplace from 'react-string-replace';

import { Text, TextProps } from '../cdl/Text/Text';

interface PartlyBoldTranslationProps {
    translation: string;
    fontWeight?: TextProps['fontWeight'];
}

export const PartlyBoldTranslation = ({ translation, fontWeight = 700 }: PartlyBoldTranslationProps) => {
    return (
        <>
            {reactStringReplace(translation, /\[([^\]]+)]/g, (match, i) => (
                <Text key={i} fontWeight={fontWeight}>
                    {match}
                </Text>
            ))}
        </>
    );
};
